import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LabReqBaseComponent } from '../lab-req-base/lab-req-base.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'app-lab-req-ab',
  templateUrl: './lab-req-ab.component.html',
  styleUrls: ['./lab-req-ab.component.less']
})
export class LabReqAbComponent extends LabReqBaseComponent implements OnInit {
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      accession: [''],
      patient: this.fb.group({
        PHN: [''],
        exp: [''],
        dob: [''],
        lastName: [''],
        firstName: [''],
        middleName: [''],
        alternateIdentifier: [''],
        preferredName: [''],
        male: [false],
        female: [false],
        nonBinary: [false],
        PreferNotToDisclose: [false],
        phone: [''],
        address: [''],
        city: [''],
        prov: [''],
        postal: ['']
      }),
      provider: this.fb.group({
        name: [''],
        copyName1: [''],
        copyName2: [''],
        address: [''],
        phone: [''],
        address1: [''],
        address2: [''],
        ccProviderId: [''],
        ccSubmitterId: [''],
        legacyId: [''],
        phone1: [''],
        phone2: [''],
        clinicName: [''],
        clinicName1: [''],
        clinicName2: ['']
      }),
      collection: this.fb.group({
        date: [''],
        time: [''],
        location: [''],
        collectorId: ['']
      }),
      fasting: this.fb.group({
        routine: [false],
        stat: [false],
        requisitionDate: [''],
        hoursFasting: [''],
        thirdPartyBill: [false],
        client: ['']
      }),
      hematology: this.fb.group({
        cbcAndDifferential: [false],
        dDimer: [false],
        INR: [false],
        reticulocyte: [false],
        cbcNoDifferential: [false]
      }),
      endocrine: this.fb.group({
        random: [false],
        AM: [false],
        PM: [false],
        estradiol: [false],
        FSH: [false],
        LH: [false],
        PTH: [false],
        progesterone: [false],
        prolactin: [false],
        testosteroneTotal: [false],
        TSH: [false],
        TSH_Progressive: [false]
      }),
      clinicalInformation: this.fb.group({
        clinicalInformation: ['']
      }),
      generalChemistry: this.fb.group({
        clinicalInformation: [false],
        albumin: [false],
        ALP: [false],
        ALT: [false],
        bilirubin: [false],
        conjugated: [false],
        calcium: [false],
        CRP: [false],
        CK: [false],
        eGFR: [false],
        ferritin: [false],
        GGT: [false],
        glucoseFasting: [false],
        GDS: [false],
        glucoseToleranceGestational2h: [false],
        glucoseRandom: [false],
        glucoseTolerance2h: [false],
        hemoglobinA1c: [false],
        HCG: [false],
        IgA: [false],
        IgG: [false],
        lgM: [false],
        lipase: [false],
        magnesium: [false],
        phosphate: [false],
        PSA: [false],
        proteinElectrophoresisSerum: [false],
        NA: [false],
        K: [false],
        totalProtein: [false],
        urate: [false],
        lipidPanel: [false],
        cholesterolTotal: [false],
        triglycerides: [false],
        FRS: [false],
        systolicBloodPressure: [''],
        tobaccoUse: this.fb.group({
          yes: [false],
          no: [false]
        }),
        treatedForHighBloodPressure: this.fb.group({
          yes: [false],
          no: [false]
        }),
        diabetic: this.fb.group({
          yes: [false],
          no: [false]
        }),
        chronicKidneyDisease: this.fb.group({
          yes: [false],
          no: [false]
        }),
        atherosclerosis: this.fb.group({
          yes: [false],
          no: [false]
        }),
        firstDegreeRelativeWithCardiovascularDisease: this.fb.group({
          yes: [false],
          no: [false]
        })
      }),
      sterileBodyFluid: this.fb.group({
        yes: [false],
        fluidType: [''],
        source: [''],
        tests: ['']
      }),
      miscellaneous: this.fb.group({
        FIT: [false],
        H: [false],
        HI: [false]
      }),
      urine: this.fb.group({
        urinalysis: [false],
        pregnancyTest: [false],
        proteinRandom: [false],
        albumin: this.fb.group({
          random: [false],
          h24: [false]
        }),
        creatinine: this.fb.group({
          random: [false],
          h24: [false]
        }),
        cortisol: this.fb.group({
          random: [false],
          h24: [false]
        }),
        proteinTotal: this.fb.group({
          random: [false],
          h24: [false]
        }),
        proteinElectrophoresis: this.fb.group({
          random: [false],
          h24: [false]
        }),
        creatinineClearance24h: [false],
        ht: [''],
        wt: [''],
        totalVolume: [''],
        startDate1: [''],
        startDate2: [''],
        endDate1: [''],
        endDate2: ['']
      }),
      transfusionMedicine: this.fb.group({
        DAT: [false],
        RHIG: [false]
      }),
      cardiology: this.fb.group({
        electrocardiogram: [false],
        dynalifePanel: [false],
        other: [false],
        otherText: [''],
        calgary: ['']
      }),
      immunology: this.fb.group({
        epstein: [false],
        IgM: [false],
        IgG: [false],
        hepatitisBSurfaceAntigen: [false],
        hepatitisBSurfaceAntibody: [false],
        hepatitisCVirusSerology: [false],
        HIV: [false],
        mononucleosisScreen: [false],
        rheumatoidFactor: [false],
        rubellaImmunitySerologyIgG: [false],
        syphilisScreen: [false]
      }),
      drugLevelsMonitoring: this.fb.group({
        ethanolLevelBlood: [false],
        doseRoute: this.fb.group({
          oral: [false],
          IV: [false],
          other: [false]
        }),
        doseRegimen: [''],
        howLongOnCurrentRegimen: [''],
        dateOfLastDoseOrIVComplete: [''],
        timeOfLastDoseOrIvComplete: [''],
        dateOfNextDoseOrIvStart: [''],
        timeOfNextDoseOrIvStart: [''],
        carbamazepine: [false],
        phenytoinTotal: [false],
        cyclosporinePreDose: [false],
        sirolimus: [false],
        cyclosporine2HPost: [false],
        tacrolimus: [false],
        digoxin: [false],
        theophylline: [false],
        lithium: [false],
        valproate: [false],
        phenobarbital: [false],
        other: [false],
        otherText: [false],
        gentamicin: this.fb.group({
          pre: [false],
          post: [false],
          interval: [false],
          other: [false]
        }),
        tobramycin: this.fb.group({
          pre: [false],
          post: [false],
          interval: [false],
          other: [false]
        }),
        vancomycin: this.fb.group({
          pre: [false],
          post: [false],
          interval: [false],
          other: [false]
        })
      }),
      additionalTests: this.fb.group({
        additionalTests: ['']
      }),
      urineDrugTestingPanels: this.fb.group({
        reasonForRequest: [''],
        opioidDependencyPanel: [false],
        buprenorphine: [false],
        methadone: [false],
        morphine: [false],
        hydromorphone: [false],
        other: [false],
        otherText: [''],
        generalToxicologyPanel: [false]
      }),
      chlamydiaGonorrhea: this.fb.group({
        chlamydiaGonorrheaScreen: [false],
        initialScreen: [false],
        rescreen: [false],
        testOfCure: [false],
        urine: [false],
        endocervix: [false],
        urethra: [false],
        vagina: [false],
        rectal: [false],
        throat: [false],
        eye: [false]
      })
    });
  }
}